import React, { useState, useEffect} from "react";
import UspItems from './UspItems';
import { get, post } from '../../util/axiosConfig/AxiosConfig'
import Loader from '../../util/preloader/Preloader';

const OursUsp = () => {
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // fetchData();
        // sendData();
    }, []);

    const fetchData = async () => {
            try {
                setLoading(true);
                const response = await get('/posts/');
                console.log(response);
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        };


    const sendData = async () => {
        const data = {
            "userId": 1,
            "id": 1,
            "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
            "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
        };

        try {
            const response = await post('/posts', data);
            setLoading(true);
            console.log(response);
        } catch (error) {
            setLoading(false);
            console.error(error);
        }
    };


    // get function
    // get('/posts')
    //     .then(response => {
    //         setLoading(true)
    //         console.log(response);
    //     })
    //     .catch(error => {
    //         setLoading(false)
    //         console.error(error);
    //     });

    // const data = {
    //     "userId": 1,
    //     "id": 1,
    //     "title": "sunt aut facere repellat provident occaecati excepturi optio reprehenderit",
    //     "body": "quia et suscipit\nsuscipit recusandae consequuntur expedita et cum\nreprehenderit molestiae ut ut quas totam\nnostrum rerum est autem sunt rem eveniet architecto"
    // }

    // post function
    // post('/posts', data)
    //     .then(response => {
    //         console.log(response);
    //     })
    //     .catch(error => {
    //         console.error(error);
    //     });

    // const uspData = [
    //     {
    //         uspId: '1',
    //         title: "Saves Money",
    //         description: "Access quality educational content without breaking the bank, ensuring quality education is affordable for everyone. ",
    //     },
    //     {
    //         uspId: '2',
    //         title: "Flexible Learning ",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '3',
    //         title: "Lorem Ipsum 3",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '4',
    //         title: "Lorem Ipsum 4",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '5',
    //         title: "Lorem Ipsum 5",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '6',
    //         title: "Lorem Ipsum 6",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '7',
    //         title: "Lorem Ipsum 7",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     },
    //     {
    //         uspId: '8',
    //         title: "Lorem Ipsum 8",
    //         description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit",
    //     }
    // ];

    return (
        <React.Fragment>
        
            <div className="container usp_sec_main_title">
                <h2 className="usp_sec_title">Why Choose Finlabs Learning Hub?</h2>
            </div>
            <div className="usp_main">
                <div className="container">
                    <UspItems/>
                        {/* {uspData.map((usp, index) => (
                            <UspItems/>
                        ))} */}
                    
                </div>
            </div>
        </React.Fragment>
    )
}

export default OursUsp;